import { Theme } from '@material-ui/core';
import { Property } from 'csstype';
import { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';

interface GcpBoxProps extends HTMLAttributes<HTMLDivElement> {
  // PADDING LEFT  * 8
  pl?: number;
  // PADDING RIGHT  * 8
  pr?: number;
  // PADDING TOP  * 8
  pt?: number;
  // PADDING BOTTOM * 8
  pb?: number;
  // MARGIN LEFT  * 8
  ml?: number;
  // MARGIN RIGHT * 8
  mr?: number;
  // MARGIN TOP * 8
  mt?: number;
  // MARGIN BOTTOM * 8
  mb?: number;
  isFullWidth?: boolean;
  isFullHeight?: boolean;
  display?: Property.Display;
  justifyContent?: Property.JustifyContent;
  alignItems?: Property.AlignItems;
  flexDirection?: Property.FlexDirection;
  theme?: Theme;
  width?: Property.Width;
  height?: Property.Height;
  textAlign?: Property.TextAlign;
  flexWrap?: Property.FlexWrap;
  gap?: number;
  position?: Property.Position;
}

const GcpBox: FC<GcpBoxProps> = styled.div<GcpBoxProps>`
  ${(props): string => props?.isFullWidth && 'width: 100%;'}
  ${(props): string =>
    Number.isInteger(props?.pt) &&
    `padding-top: ${props.theme.spacing(props.pt)}px;`}
  ${(props): string =>
    Number.isInteger(props?.pb) &&
    `padding-bottom: ${props.theme.spacing(props.pb)}px;`}
  ${(props): string =>
    Number.isInteger(props?.pl) &&
    `padding-left: ${props.theme.spacing(props.pl)}px;`}
  ${(props): string =>
    Number.isInteger(props?.pr) &&
    `padding-right: ${props.theme.spacing(props.pr)}px;`}
   ${(props): string =>
    Number.isInteger(props?.mt) &&
    `margin-top: ${props.theme.spacing(props.mt)}px;`}
   ${(props): string =>
    Number.isInteger(props?.mb) &&
    `margin-bottom: ${props.theme.spacing(props.mb)}px;`}
  ${(props): string =>
    Number.isInteger(props?.ml) &&
    `margin-left: ${props.theme.spacing(props.ml)}px;`}
  ${(props): string =>
    Number.isInteger(props?.mr) &&
    `margin-right: ${props.theme.spacing(props.mr)}px;`}
  ${(props): string => props.display && `display: ${props.display};`}
  ${(props): string =>
    props.justifyContent && `justify-content: ${props.justifyContent};`}
  ${(props): string => props?.alignItems && `align-items: ${props.alignItems};`}
  ${(props): string =>
    props?.flexDirection && `flex-direction: ${props.flexDirection};`}
  ${(props): string => props?.width && `width: ${props.width};`}
  ${(props): string => props?.height && `height: ${props.height};`}
  ${(props): string => props?.textAlign && `text-align: ${props.textAlign};`}
    ${(props): string => props?.flexWrap && `flex-wrap: ${props.flexWrap};`}
  ${(props): string =>
    props?.gap && `gap: ${props.theme.spacing(props.gap)}px;`}
  ${(props): string => props?.isFullHeight && `height: 100%;`}
  ${(props): string => props?.position && `position: ${props.position};`}
`;

export default GcpBox;
